import React, { FC } from 'react';
import { getUserInitials } from 'utils/functions';

type DisplayNameColor = 'red' | 'blue';

type DisplayNameIconProps = {
  color?: DisplayNameColor;
  size?: 'normal' | 'large';
  active?: boolean;
  user: {
    first_name: string;
    last_name: string;
  };
};
const DisplayNameIcon: FC<DisplayNameIconProps> = ({
  color = 'blue',
  size = 'normal',
  active = false,
  user
}) => {
  const initials = getUserInitials(user);
  return (
    <div
      className={` border-[1px] relative ${
        size === 'large' ? 'min-w-[40px] w-10 h-10' : 'min-w-[32px] w-8 h-8'
      } rounded-[100%] flex items-center justify-center ${
        color === 'blue' ? 'border-blue-2' : color === 'red' && '  border-red-2'
      }`}>
      <div
        className={` text-sm  font-medium  flex justify-center uppercase items-center rounded-[100%] w-[96%] h-[96%] ${
          color === 'blue'
            ? 'text-blue-5 bg-blue-1  border-blue-2'
            : color === 'red' && 'text-red-5 bg-red-1  border-red-2'
        }`}>
        {initials}
      </div>
      {active && (
        <div className='absolute top-[.5px] -right-[.5px] w-2 h-2 rounded-full bg-green-4'></div>
      )}
    </div>
  );
};

export default DisplayNameIcon;
